import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/bootstrap.min.css';
import './assets/css/green-audio-player.css';
import './assets/css/icofont.css';
import './assets/css/jquery.calendar.css';
import './assets/css/swiper.min.css';
import './assets/css/main.css';
import './components/Events/_Events.scss';
import './components/HomeLinks/_HomeLinks.scss';
import 'owl.carousel/dist/assets/owl.carousel.css';
import './assets/css/magnific-popup.min.css';
import 'owl.carousel';
import '@popperjs/core';
import 'bootstrap';

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
